import isFunction from "lodash/isFunction"
import debounce from "lodash/debounce"
import tableMixin from "./table-mixin"
import { getValue } from "./utils"
import { decimalAdd } from "../../utils/helper"

export default {
  props: {
    summaryText: String,
    summaryRender: Function,
    spanMethod: Function,
    rowClass: Function,
  },
  mixins: [tableMixin],
  data() {
    return {
      row: [],
    }
  },
  computed: {
    debounceResizeHandler() {
      return debounce(this.resizeHandler, 60)
    },
  },
  watch: {
    "store.state.filteredRows": {
      immediate: true,
      handler() {
        this.setRowData()
      },
    },
    "store.state.columns": {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.$isServer || !this.$el || this.fixed) {
            return
          }
          this.setFooterHeight()
        })
      },
    },
  },
  mounted() {
    if (!this.fixed) {
      window.addEventListener("resize", this.debounceResizeHandler)
    }
  },
  beforeDestroy() {
    if (!this.fixed) {
      window.removeEventListener("resize", this.debounceResizeHandler)
    }
  },
  methods: {
    setFooterHeight() {
      const height = this.$el.offsetHeight
      const { footerHeight } = this.store.layout

      if (height !== footerHeight) {
        this.store.setLayout("footerHeight", height)
      }
    },
    resizeHandler() {
      this.store.setLayout("footerHeight", this.$el.offsetHeight)
    },
    setRowData() {
      const rows = this.store.state.filteredRows
      const render = this.summaryRender || this.defaultSummaryRender
      const rowIndex = rows.length
      const summary = {
        content: this.summaryText,
        ...(this.spanMethod ? this.spanMethod({ rowIndex, colIndex: 0 }) : {}),
      }

      let row = this.flattenColumns.map((column, index) => {
        return {
          content: render(column, rows),
          ...(this.spanMethod ? this.spanMethod({ column, rowIndex, colIndex: index }) : {}),
        }
      })

      if (this.showSelectCol) {
        row.unshift(summary)
      } else if (this.fixed !== "right") {
        row[0] = summary
      }

      this.row = row
    },
    defaultSummaryRender(column, rows) {
      const isAllNumber = rows.every(row => !isNaN(Number(getValue({ row, column }))))
      return isAllNumber ? rows.reduce((total, row) => {
        return decimalAdd(total, Number(getValue({ row, column })))
      }, 0) : "N/A"
    },
  },
  render() {
    return (
      <table cellpadding="0" cellspacing="0" border="0" style={this.tableStyle}>
        <colgroup>
          {this.showSelectCol && <col width={this.store.layout.selectColWidth} />}
          {this.flattenColumns.map((column, index) => <col key={index} width={column.width || 10086} />)}
        </colgroup>
        <tbody>
          <tr
            class={[isFunction(this.rowClass) ? this.rowClass({ row: this.row, rowIndex: this.store.state.filteredRows.length }) : this.rowClass]}
          >
            {this.row.map((column, index) => (
              <td key={index} colspan={column.colSpan}>
                <div
                  class="mm-table-cell mm-table-cell--ellipsis"
                  title={column.content}>
                  {column.content}
                </div>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    )
  },
}
